module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@3x-c806104a4198b90cda1a631ab93432a8.png";